<template>
    <v-data-table
        v-model="selectedTableRows"
        :show-select="isSelectable"
        :headers="headers"
        :items="listCatalogues"
        :page="page"
        :pageCount="numberOfPages"
        :options.sync="options"
        :server-items-length="totalRecords"
        :footer-props="{
            showFirstLastPage: true,
            'items-per-page-options': [10, 20, 50],
        }"
        item-key="userId"
    >
        <template v-slot:[`item.stateID`]="{ item }">
            <v-chip
                :color="getColor(item.stateID)"
                pill
                dark
                class="status-column"
            >
                {{
                    item.stateID == 1
                        ? $t("backoffice.general.active-status")
                        : $t("backoffice.general.inactive-status")
                }}
            </v-chip>
        </template>

        <template v-slot:[`item.tecDocProfileId`]="{ item }">
            <span>{{ getCatalogNameById(item.tecDocProfileId) }}</span>
        </template>

        <template v-slot:[`item.updatedOn`]="{ item }">
            {{ item.updatedOn | formatDate }}
        </template>
        <template v-slot:[`item.expiresOn`]="{ item }">
            {{ item.expiresOn | formatDate }}
        </template>
        <template v-slot:[`item.lastLogin`]="{ item }">
            {{ item.lastLogin | formatDate }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span
                        class="mr-2 p-0 circle"
                        @click="editCatalogue(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <img
                            src="/images/_SVGs/bo/edit_pencil.svg"
                            class="circle"
                            onload="SVGInject(this)"
                            width="12"
                            height="12"
                        />
                    </span>
                </template>
                <span>{{ $t("backoffice.tecdoc.update-license") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span
                        class="mr-2 p-0 circle"
                        @click="removeCatalogue(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <img
                            src="/images/_SVGs/bo/remove.svg"
                            class="circle"
                            onload="SVGInject(this)"
                            width="12"
                            height="12"
                        />
                    </span>
                </template>
                <span>{{ $t("backoffice.tecdoc.remove-catalogue") }}</span>
            </v-tooltip>
        </template>
    </v-data-table>
</template>

<script>
export default {
    props: {
        listCatalogues: { type: Array, required: true, default: [] },
        perfilCatalogues: { type: Array, required: true },
        totalRecords: { type: Number, required: true, default: 0 },
        isSelectable: { type: Boolean, required: true, default: false },
    },

    data() {
        return {
            headers: [
                {
                    text: this.$t("backoffice.general.entity"),
                    value: "company",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.tecdoc.table.client-license"),
                    align: "start",
                    value: "firstName",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.tecdoc.table.client-no"),
                    value: "userId",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.tecdoc.table.login"),
                    align: "start",
                    value: "username",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.profile"),
                    value: "tecDocProfileId",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.tecdoc.table.vrm-login"),
                    value: "vrmLogin",
                    align: "center",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.email"),
                    value: "email",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.tecdoc.datatable-list-catalogues.headers.expiration-date"
                    ),
                    value: "expiresOn",
                    align: "center",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.status"),
                    value: "stateID",
                    align: "center",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.tecdoc.table.last-login"),
                    value: "lastLogin",
                    align: "center",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "right",
                    class: "header-table-color",
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            selectedTableRows: [],
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTable", this.options);
            },
            immediate: false,
        },
        selectedTableRows(newItem, OldItem) {
            this.$emit("select-export-tecdoc", newItem);
        },
    },
    methods: {
        getColor(stateID) {
            if (stateID == 1) return "green";
            else if (stateID == 2) return "red";
            else return "orange";
        },
        editCatalogue(item) {
            this.$emit("editCatalogue", item);
        },
        removeCatalogue(item) {
            this.$emit("removeCatalogue", item);
        },
        getCatalogNameById(tecDocProfileId) {
            const findCatalogName = this.perfilCatalogues.find(
                (c) => c.catalogTecDocId == tecDocProfileId
            );
            if (findCatalogName) {
                return findCatalogName.name;
            }
            return "";
        },
    },
};
</script>